import { gql } from "@apollo/client";
import { onUpdate } from "../../../function/onUpdate";
import { getReceivingAndShipping, updateReceivingAndShipping } from "./query";
import updatePOOpenQtyFromArray from "../../../function/utilityAPI/updatePOOpenQtyFromArray";

export default async function onUpdateShipping({ values, client }) {
  const fieldsToUpdate = [
    { field: "courierID", createUpdate: false },
    { field: "trackingNumber", createUpdate: true },
    { field: "packingDetails", createUpdate: false },
    { field: "itemNumber", createUpdate: false },
    { field: "number", createUpdate: false },
    { field: "materialID", createUpdate: true },
    { field: "qty", createUpdate: true },
    { field: "poID", createUpdate: true },
    { field: "date", createUpdate: false },
  ];

  // Fetch current state before the update so we can detect a qty change
  const { data: currentData } = await client.query({
    query: gql(getReceivingAndShipping),
    variables: { id: values.id },
    fetchPolicy: "network-only",
  });
  const current = currentData?.getReceivingAndShipping;
  const oldQty = parseFloat(current?.qty) || 0;
  const newQty = parseFloat(values.qty);
  const poID = current?.poID || values.poID;

  const result = await onUpdate({
    type: "ReceivingAndShipping",
    values,
    mutation: updateReceivingAndShipping,
    query: getReceivingAndShipping,
    getInitialValue: null,
    fieldsToUpdate,
    client,
    refetchQueries: [""],
  });

  // If qty changed, adjust the PO's openQty by the delta
  if (!isNaN(newQty) && newQty !== oldQty && poID) {
    const delta = newQty - oldQty;
    await updatePOOpenQtyFromArray({
      client,
      arr: [{ poID, qty: Math.abs(delta) }],
      // shipped more → deduct from open; shipped less → add back to open
      type: delta > 0 ? "deduct" : "add",
    });
  }

  return result;
}
